import { Col, Drawer, Row } from "antd";
import { DrawerUserCard } from "./DrawerUserCard";
import { MenuButton } from "./MenuButton";
import { getColor } from "../../resources/theme";
import { selectCurrentUserReservations } from "../../../state/reservations/selectors";
import HpIcon, { Icons } from "react-hp-icons";
import React, { useGlobal } from "reactn";
import styled from "styled-components";
import { useAuth } from "hooks/useAuth";
import { TemporaryUserComponent } from "views/mobile/components/common/Drawer";
import { useHistory } from "react-router";
import { ExitTemporaryUserModal } from "views/components/common/TemporaryUserPopUp";
import { useState } from "react";
import { useLogoutWithTemporaryUser } from "hooks/useLogoutWithTemporaryUser";

const menuButtons = (tickets, reserves) => [
	{
		icon: <HpIcon type={Icons.user} size={1.2} color="#000" />,
		link: "/profile",
		text: "Mi perfil",
		type: "text",
		shape: "round",
	},
	{
		icon: (
			<HpIcon
				type={Icons.ticket}
				badge={
					tickets.active.length && tickets.active.length.toString()
				}
				size={1.2}
				badgeSize="large"
				color="#000"
			/>
		),
		link: "/my-tickets",
		text: "Mis Tickets",
		type: "text",
		shape: "round",
	},
	{
		icon: (
			<HpIcon
				type={Icons.calendar}
				badge={reserves.length && reserves.length.toString()}
				size={1.2}
				badgeSize="large"
				color="#000"
			/>
		),
		link: "/my-reservations",
		text: "Mis Reservas",
		type: "text",
		shape: "round",
	},
	{
		icon: <HpIcon type={Icons.heart} size={1.2} color="#000" />,
		link: "/favorites",
		text: "Mis Favoritos",
		type: "text",
		shape: "round",
	},
];

export const MenuDrawer = ({ open, setOpen }) => {
	// export const MenuDrawer = ({ setOpen }) => {
	// const open = true;
	const { actionWithTemporary } = useLogoutWithTemporaryUser();
	const history = useHistory();
	const [showExitModal, setShowExitModal] = useState(false);
	const [buttonType, setButtonType] = useState("");
	const { isLoggedIn, isLoggedInTemporary } = useAuth();
	const [global] = useGlobal();
	const {
		user,
		tickets,
		ticketsv2,
		myReservations: { byId: reservesById },
	} = global;
	const reserves =
		selectCurrentUserReservations(Object.values(reservesById)).filter(
			({ deleted }) => !deleted
		) || [];

	const logInWithRealUser = (type) => {
		actionWithTemporary(type);
		setShowExitModal(false);
		setOpen(false);
	};
	const goToFAQ = () => {
		history.push("/faq");
		setOpen(false);
	};

	const openExitModal = (type) => {
		setShowExitModal(true);
		setButtonType(type);
	};

	return (
		<>
			{showExitModal && (
				<ExitTemporaryUserModal
					setShowExitModal={setShowExitModal}
					desktop={true}
					logInWithRealUser={logInWithRealUser}
					buttonType={buttonType}
				/>
			)}

			<StyledDrawer
				placement="right"
				closable={true}
				onClose={() => setOpen(false)}
				visible={open}
				title={
					!isLoggedInTemporary && (
						<DrawerUserCard
							user={user}
							setOpen={setOpen}
						></DrawerUserCard>
					)
				}
			>
				{!isLoggedInTemporary && isLoggedIn && (
					<>
						{menuButtons(ticketsv2, reserves).map(
							(menuButton, i) => (
								<Row key={i}>
									<Col style={{ margin: 8 }}>
										<MenuButton
											onClick={() => setOpen(false)}
											place="drawer"
											menuButton={menuButton}
										></MenuButton>
									</Col>
								</Row>
							)
						)}
						<Row style={{ marginTop: 12 }}>
							<Col span={24}>
								<MenuButton
									onClick={() => setOpen(false)}
									menuButton={{
										icon: null,
										isExternal: true,
										link: "/command/#/",
										text: "Administrador",
										type: "primary",
										shape: "round",
									}}
								></MenuButton>
							</Col>
						</Row>
						<Row style={{ marginTop: 12 }}>
							<Col span={24}>
								<MenuButton
									onClick={() => setOpen(false)}
									menuButton={{
										icon: null,
										isExternal: true,
										link: "/command-v2",
										text: "Centro de mando V2",
										type: "primary",
										shape: "round",
									}}
								></MenuButton>
							</Col>
						</Row>
					</>
				)}
			</StyledDrawer>

			{isLoggedInTemporary && (
				<StyledDrawer
					open={open}
					drawerStyle={{ backgroundColor: "white" }}
					right
					visible={open}
					onClose={() => setOpen(false)}
					isLoggedInTemporary={isLoggedInTemporary}
				>
					<TemporaryUserComponent
						isLoggedInTemporary={isLoggedInTemporary}
						// closeDrawer={closeDrawer}
						goToFAQ={goToFAQ}
						openExitModal={openExitModal}
					/>
				</StyledDrawer>
			)}
		</>
	);
};

const StyledDrawer = styled(Drawer)`
	.ant-drawer-content-wrapper {
		width: 360px !important;
	}
	.ant-drawer-body {
		padding: ${(props) =>
			props.isLoggedInTemporary ? "0 !important" : 24};
	}
	.ant-drawer-header {
		padding: 0 !important;
		background-color: ${getColor("elementBg")};
	}

	& p {
		text-align: center;
		font-weight: ${(props) => (props.isLoggedInTemporary ? 500 : "normal")};
	}

	& span {
		text-align: center;
	}

	& a {
		color: #000;
		font-weight: 800;
	}
`;
